export const SIZES = { small: "20px", medium: "24px", large: "28px", inherit: "1em" };
